import React, { useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

import IdentityUsersTab from "components/identity-display/identity-users-tab";
import { convertTimestampToDate } from "helpers/time";
import { SearchTableBodyRowIdentitySearchProps } from "types/search-display";

const SearchTableBodyRowIdentitySearch = ({
  row,
}: SearchTableBodyRowIdentitySearchProps) => {
  const [shouldLoad, setShouldLoad] = useState(false);

  return (
    <Accordion
      onChange={(_e, expanded) => {
        if (expanded) {
          setShouldLoad(true);
        }
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid
          container
          alignItems="flex-end"
          justifyContent="space-between"
          padding="10px"
        >
          <Grid item>
            <div>
              <Link
                to={`/identity/${row.identityId}`}
                className="remove-link-style"
              >
                <Typography
                  sx={{ fontWeight: "bold", fontSize: "1.3em" }}
                  align="left"
                  marginBottom="5px"
                  color="primary"
                >
                  {row.email}
                </Typography>
              </Link>
              <Typography align="left">
                <b>Identity ID:</b> {row.identityId}
              </Typography>
              <Typography align="left">
                <b>Auth0 ID:</b> {row.authId}
              </Typography>
              <Typography align="left">
                <b>Creation date:</b>{" "}
                {row.createdAt
                  ? convertTimestampToDate(row.createdAt).toDateString()
                  : "N/A"}
              </Typography>
              <Typography align="left">
                <b>Users count:</b> {row.usersCount}
              </Typography>
            </div>
          </Grid>
          <Grid item>
            <Link
              to={`/identity/${row.identityId}`}
              className="remove-link-style"
            >
              <Button variant="contained" color="primary">
                Manage Identity
              </Button>
            </Link>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <IdentityUsersTab
          shouldLoad={shouldLoad}
          identityID={row.identityId}
          email={row.email}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default SearchTableBodyRowIdentitySearch;
